import { object, string } from "yup";

const domainRegex = /^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,}$/;

let choosePlanSchema = object({
  website: string()
    .required("Website cannot be empty.")
    .matches(
      domainRegex,
      "Please enter a valid domain (e.g., example.com)."
    )
    .lowercase()
    .trim(),
});

export default choosePlanSchema;